package com.zaurh.portfolio.utils

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import org.jetbrains.compose.resources.Font
import portfolio.shared.generated.resources.Res
import portfolio.shared.generated.resources.poppins_bold
import portfolio.shared.generated.resources.poppins_italic
import portfolio.shared.generated.resources.poppins_light
import portfolio.shared.generated.resources.poppins_regular
import portfolio.shared.generated.resources.poppins_thin

@Composable
fun getPoppinsFont(): FontFamily {
    return FontFamily(
        Font(
            resource = Res.font.poppins_regular,
            weight = FontWeight.Normal
        ),
        Font(
            resource = Res.font.poppins_bold,
            weight = FontWeight.Bold
        ),
        Font(
            resource = Res.font.poppins_italic,
            style = FontStyle.Italic
        ),
        Font(
            resource = Res.font.poppins_thin,
            weight = FontWeight.Thin
        ),
        Font(
            resource = Res.font.poppins_light,
            weight = FontWeight.Light
        ),
    )
}